import React, {PropTypes} from 'react';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';
import InputFieldSimple from 'components/input-field/input-field-simple';

class ClearingNumberField extends React.Component {

  static propTypes = {
    value: PropTypes.string.isRequired,
    isValid: PropTypes.bool.isRequired,
    suppressError: PropTypes.bool.isRequired,
    errorMessage: PropTypes.string.isRequired,
    selectedBank: PropTypes.string.isRequired,
    changed: PropTypes.func.isRequired,
    blurred: PropTypes.func.isRequired
  };

  constructor (props, context) {
    super(props, context);

    this.state = {
      name: 'clearingNr',
      type: 'text',
      isDisabled: this.props.selectedBank === 'INITIAL',
      isVisible: this.props.selectedBank !== 'NORDEA_PERSON',
      label: proxyCounterpart('CLEARING_NR_LABEL_' + props.selectedBank),
      placeholder: proxyCounterpart('CLEARING_NR_PLACEHOLDER_' + props.selectedBank)
    };

    this.clearingNumberElement = null;
    this.setClearingNumberElement = this.setClearingNumberElement.bind(this);

    this.changedClearingNumber = this.changedClearingNumber.bind(this);
    this.blurredClearingNumber = this.blurredClearingNumber.bind(this);
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.selectedBank !== nextProps.selectedBank) {
      this.setState({
        isDisabled: nextProps.selectedBank === 'INITIAL',
        isVisible: nextProps.selectedBank !== 'NORDEA_PERSON',
        label: proxyCounterpart('CLEARING_NR_LABEL_' + nextProps.selectedBank),
        placeholder: proxyCounterpart('CLEARING_NR_PLACEHOLDER_' + nextProps.selectedBank)
      });

      if (nextProps.selectedBank === 'NORDEA_PERSON') {
        this.changedClearingNumber('3300');
      }
    }
  }

  format (value) {
    if (this.props.selectedBank === 'IBAN') {
      value = value.toUpperCase();
    }
    return value.replace(/[ .,_-]/g, '').trim();
  }

  changedClearingNumber (value) {
    value = this.format(value);
    this.props.changed(value);
  }

  blurredClearingNumber (value) {
    value = this.format(value);
    this.props.blurred(value);
  }

  setClearingNumberElement (el) {
    if (el) {
      this.clearingNumberElement = el;
    }
  }

  shouldShowError () {
    return !this.props.suppressError && !this.props.isValid;
  }

  render () {
    return (
      <InputFieldSimple
        value={this.props.value}
        errorMessage={this.props.errorMessage}
        showError={this.shouldShowError()}

        type={this.state.type}
        name={this.state.name}
        label={this.state.label}
        placeholder={this.state.placeholder}
        helpMessage={this.state.helpMessage}
        isDisabled={this.state.isDisabled}
        isVisible={this.state.isVisible}
        element={this.setClearingNumberElement}

        changed={this.changedClearingNumber}
        blurred={this.blurredClearingNumber}
      />
    );
  }
}

export default ClearingNumberField;




/** WEBPACK FOOTER **
 ** ./src/views/settings/salary-info/clearing-number-field.js
 **/